import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {selectCurrentUser} from "../../../../Redux/Selectors/userSelectors";
import {StreamBankLink} from "../../StreamBankLink";
import {service as SpeciesListService} from '../../../../Services/SpeciesListService';
import {service as SpeciesService} from '../../../../Services/SpeciesService';
import {ViewSpeciesModal} from "../../../Pages/SpeciesLists/Common/Modals/ViewSpeciesModal";

export const CreateSpeciesActivityFeedItemDescription = props => {
    const {Event: contextNodeActivity = null} = props;
    const {Activity: activity = null} = contextNodeActivity;
    const {data = null} = activity;
    const species = data?.newValue;
    const speciesTitle = SpeciesService.GetFullTitle(species);
    
    const currentUser = useSelector(selectCurrentUser);

    const [showModal, setShowModal] = useState(false);
    const [speciesLists, setSpeciesLists] = useState([]);
    
    const loadSpeciesListLinks = async (speciesRequestSpeciesLists) => {
        if(!speciesRequestSpeciesLists) {
            return;
        }
        
        try {
            const promises = Promise.allSettled(
                speciesRequestSpeciesLists.map((speciesRequestSpeciesList) => {
                    SpeciesListService.GetSpeciesList(speciesRequestSpeciesList?.speciesListId);
                })
            );

            const outcomes = await promises;

            setSpeciesLists(
                outcomes.map(({value: speciesList, reason}) => {
                    return speciesList
                })
                .filter(Boolean)
            )
        } catch (e) {
            console.log(e);
        }
    }
    
    useEffect(() => {
        void loadSpeciesListLinks(species?.SpeciesRequest?.SpeciesRequestSpeciesList);
    }, [species])
    
    let reviewComment = null;
    let verb = 'added';
    if(species?.SpeciesRequest) {
        if(Number(currentUser?.userId) === Number(species?.SpeciesRequest?.requestedByUserId)) {
            reviewComment = species?.SpeciesRequest?.reviewerNotes;
        }
    }

    let speciesListLinks = null;
    if(speciesLists.length) {
        speciesListLinks = <div>
            It may be relevant to the following custom species lists:
            {
                speciesLists.map((speciesList) => (
                    <StreamBankLink
                        Href={`/speciesLists/` + speciesList?.speciesListId}>{speciesList?.name}
                    </StreamBankLink>
                ))
            }
        </div>
    }
    
    return <p>
        <ViewSpeciesModal
            show={showModal}
            species={species}
            onHide={() => setShowModal(false)}
            warning={"The below information is a point-in-time snapshot of the species data which may be outdated. "}
        />
        {activity.User?.name} {verb}
        {' '}
        <a className="link-primary" onClick={_ => setShowModal(true)}>
            {speciesTitle}
        </a>
        {' '}
        to the Global Species list.
        {reviewComment}
        {speciesListLinks}
    </p>;
};


